module.exports = __webpack_public_path__ + "e896f84374883b875a23f6691add3fa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/autodesk_2022_chart.png
// module id = 1637
// module chunks = 0